module.exports = __webpack_public_path__ + "img/copy.1e7af22e.svg";